export const CONFIG = {
    DEFAULT_PAGE_CONFIG: {
        appName: `Let's connect`,
        appVersion: process.env.PACKAGE_VERSION
    },
    CDN_BASE_URL: `https://cdn.public.initia-digital.co.nz`,
    CURRENT_EVENT: '2026_akl_uni_stem_careers_expo',
    IS_FORM_OPEN: true
}